var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './vitesse-dialog';
import './vitesse-button';
/**
 * <vitesse-confirm-dialog> — the one reusable confirmation modal (delete a
 * controller, delete a symbol, any destructive "are you sure"). Wraps
 * <vitesse-dialog> with a message + optional detail line + an error banner, and
 * a Cancel / confirm footer of <vitesse-button>s. The caller owns `open` and the
 * async work: handle `confirm` (do the work, set `busy`, set `error` on failure,
 * clear `open` on success) and `dialog-close` (cancel).
 *
 *   <vitesse-confirm-dialog .open=${!!target} heading="Delete controller"
 *       message=${`Delete "${target?.name}"?`} detail="This can't be undone."
 *       confirm-label="Delete" danger ?busy=${deleting} error=${err}
 *       @confirm=${doDelete} @dialog-close=${() => (target = undefined)}>
 *   </vitesse-confirm-dialog>
 */
let VitesseConfirmDialog = class VitesseConfirmDialog extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
        this.heading = '';
        this.message = '';
        /** Secondary explanatory line (optional). */
        this.detail = '';
        this.confirmLabel = 'Confirm';
        this.cancelLabel = 'Cancel';
        /** Red (destructive) confirm button when set; blue otherwise. */
        this.danger = false;
        this.busy = false;
        this.error = '';
    }
    static { this.styles = css `
    .message {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      color: var(--text-primary);
    }
    .detail {
      margin: 8px 0 0;
      font-size: 13px;
      line-height: 1.5;
      color: var(--text-secondary);
    }
    .error {
      margin: 12px 0 0;
      font-size: 13px;
      line-height: 1.4;
      color: var(--red);
    }
  `; }
    close() {
        this.dispatchEvent(new CustomEvent('dialog-close', { bubbles: true, composed: true }));
    }
    confirm() {
        this.dispatchEvent(new CustomEvent('confirm', { bubbles: true, composed: true }));
    }
    render() {
        return html `<vitesse-dialog .open=${this.open} heading=${this.heading} @dialog-close=${this.close}>
      <p class="message">${this.message}</p>
      ${this.detail ? html `<p class="detail">${this.detail}</p>` : nothing}
      ${this.error ? html `<p class="error">${this.error}</p>` : nothing}
      <vitesse-button slot="footer" color="red" @click=${this.close}>${this.cancelLabel}</vitesse-button>
      <vitesse-button slot="footer" color=${this.danger ? 'red' : 'blue'} ?disabled=${this.busy} @click=${this.confirm}>
        ${this.busy ? '…' : this.confirmLabel}
      </vitesse-button>
    </vitesse-dialog>`;
    }
};
__decorate([
    property({ type: Boolean })
], VitesseConfirmDialog.prototype, "open", void 0);
__decorate([
    property()
], VitesseConfirmDialog.prototype, "heading", void 0);
__decorate([
    property()
], VitesseConfirmDialog.prototype, "message", void 0);
__decorate([
    property()
], VitesseConfirmDialog.prototype, "detail", void 0);
__decorate([
    property({ attribute: 'confirm-label' })
], VitesseConfirmDialog.prototype, "confirmLabel", void 0);
__decorate([
    property()
], VitesseConfirmDialog.prototype, "cancelLabel", void 0);
__decorate([
    property({ type: Boolean })
], VitesseConfirmDialog.prototype, "danger", void 0);
__decorate([
    property({ type: Boolean })
], VitesseConfirmDialog.prototype, "busy", void 0);
__decorate([
    property()
], VitesseConfirmDialog.prototype, "error", void 0);
VitesseConfirmDialog = __decorate([
    customElement('vitesse-confirm-dialog')
], VitesseConfirmDialog);
export { VitesseConfirmDialog };
//# sourceMappingURL=vitesse-confirm-dialog.js.map